class CartVariantEditor extends HTMLElement {
    constructor() {
        super();
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onOptionChange = this.onOptionChange.bind(this);
    }

    connectedCallback() {
        console.log("CartVariantEditor initialized:", this);
        this.selects = this.querySelectorAll('select');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items');

        // Prevent Dawn's cart.js from intercepting dropdown changes
        this.selects.forEach(select => {
            select.addEventListener('change', (e) => {
                e.stopPropagation();
                this.onOptionChange();
            });
        });

        // Bind to the confirm button
        this.confirmBtn = this.querySelector('.v0-confirm-btn');
        console.log("Confirm button found:", this.confirmBtn);
        if (this.confirmBtn) {
            this.confirmBtn.addEventListener('click', this.onConfirmClick);
        } else {
            console.error("CartVariantEditor: Confirm button NOT found inside component!");
        }

        // Initialize button state
        this.onOptionChange();
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    onOptionChange() {
        const options = Array.from(this.selects).map(select => select.value);
        const currentVariant = this.getVariantData().find(variant => {
            return !variant.options.some((option, index) => {
                return options[index] !== option;
            });
        });

        if (this.confirmBtn) {
            if (!currentVariant) {
                this.confirmBtn.disabled = true;
                this.confirmBtn.innerHTML = 'Unavailable';
            } else if (!currentVariant.available) {
                this.confirmBtn.disabled = true;
                this.confirmBtn.innerHTML = 'Out of stock';
            } else {
                this.confirmBtn.disabled = false;
                this.confirmBtn.innerHTML = 'Confirm';
            }
        }
    }

    onConfirmClick(e) {
        e.preventDefault();
        const options = Array.from(this.selects).map(select => select.value);

        const currentVariant = this.getVariantData().find(variant => {
            return !variant.options.some((option, index) => {
                return options[index] !== option;
            });
        });

        if (!currentVariant) {
            alert("This variant is unavailable.");
            return;
        }

        if (!currentVariant.available) {
            alert("Sorry, this variant is out of stock.");
            return;
        }

        const currentLine = parseInt(this.dataset.index);
        const quantityInput = document.getElementById(`Quantity-${currentLine}`) ||
            document.getElementById(`Drawer-quantity-${currentLine}`);
        const currentQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
        const oldVariantId = parseInt(this.dataset.currentVariantId);

        if (currentVariant.id === oldVariantId) {
            this.closeModal();
            return;
        }

        this.toggleLoading(true);
        this.swapVariant(currentLine, oldVariantId, currentVariant.id, currentQuantity);
    }

    closeModal() {
        const dialog = this.closest('dialog');
        if (dialog) dialog.close();
    }

    async swapVariant(line, oldId, newId, quantity) {
        try {
            console.log("Swapping variant using update API:", newId);
            const currentKey = this.dataset.key; // Unique line item key

            // Use cart/update.js to simultaneously remove old key and add new variant
            // This prevents "maximum quantity" stock errors when adding before removing.
            const updateParams = {
                updates: {
                    [currentKey]: 0,
                    [newId]: quantity
                }
            };

            const isDrawer = this.dataset.isDrawer === 'true';
            let sectionId = 'main-cart-items';
            if (isDrawer) {
                sectionId = 'cart-drawer';
            } else {
                const cartItemsWrapper = document.getElementById('main-cart-items');
                if (cartItemsWrapper && cartItemsWrapper.dataset.id) {
                    sectionId = cartItemsWrapper.dataset.id;
                }
            }

            const response = await fetch(window.Shopify.routes.root + `cart/update.js?sections=${sectionId},cart-icon-bubble`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(updateParams)
            });

            if (!response.ok) {
                const errText = await response.text();
                let errMsg = "Failed to update variants";
                try {
                    const errJson = JSON.parse(errText);
                    if (errJson.description) errMsg = errJson.description;
                } catch (e) { }
                throw new Error(errMsg);
            }

            const parsedState = await response.json();

            if (isDrawer && this.cartDrawer) {
                this.cartDrawer.renderContents(parsedState);
            } else if (this.cartItems) {
                const html = new DOMParser().parseFromString(parsedState.sections[sectionId], 'text/html');
                const newCartBody = html.getElementById('main-cart-items');

                if (newCartBody) {
                    document.getElementById('main-cart-items').innerHTML = newCartBody.innerHTML;
                }

                const cartIcon = document.getElementById('cart-icon-bubble');
                const newCartIcon = html.getElementById('cart-icon-bubble');
                if (cartIcon && newCartIcon) {
                    cartIcon.innerHTML = newCartIcon.innerHTML;
                }
            }

            this.closeModal();

        } catch (e) {
            console.error('Error swapping variant: ', e);
            alert("Inventory error: " + e.message);
        } finally {
            this.toggleLoading(false);
        }
    }

    toggleLoading(isLoading) {
        if (this.cartDrawer) {
            if (isLoading) this.cartDrawer.classList.add('is-empty');
            else this.cartDrawer.classList.remove('is-empty');
        }
        if (this.cartItems) {
            const wrapper = document.getElementById('main-cart-items');
            if (wrapper) wrapper.style.opacity = isLoading ? '0.5' : '1';
        }

        if (this.confirmBtn) {
            if (isLoading) {
                this.confirmBtn.classList.add('loading');
                this.confirmBtn.disabled = true;
                this.confirmBtn.innerHTML = 'Updating...';
            } else {
                this.confirmBtn.classList.remove('loading');
                this.confirmBtn.disabled = false;
                this.confirmBtn.innerHTML = 'Confirm';
            }
        }
    }
}

customElements.define('cart-variant-editor', CartVariantEditor);
